import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <ExclamationTriangleIcon className="mb-4 h-12 w-12 text-red-400" />
      <h3 className="mb-1 text-base font-semibold text-gray-900 dark:text-gray-100">
        {title ?? t('common.error')}
      </h3>
      {message && <p className="mb-4 max-w-sm text-sm text-gray-500 dark:text-gray-400">{message}</p>}
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
